import { useEffect, useState } from 'react';
import { isClient } from '../helpers/accessibility';
import { useFunction } from './useFunction';
/*
 * Hook to get a variable value based on a media query(ies)
 *
 * Usage example:
 *
 * const columnCount = useMedia(
 *  // Media queries
 *  ['(min-width: 1500px)', '(min-width: 1000px)', '(min-width: 600px)'],
 *  // Column counts (relates to above media queries by array index)
 *  [5, 4, 3],
 *  // Default column count
 *  2
 *)
 */

export var useMedia = function useMedia(queries, values, defaultValue, listenToChanges) {
  if (listenToChanges === void 0) {
    listenToChanges = false;
  }

  var mediaQueryLists = queries.map(function (q) {
    return isClient() ? window.matchMedia(q) : undefined;
  });

  var getValue = function getValue() {
    if (!isClient() || mediaQueryLists.length === 0) {
      return defaultValue;
    }

    var index = mediaQueryLists.findIndex(function (mql) {
      return mql.matches;
    });
    return index >= 0 ? values[index] : defaultValue;
  };

  var _useState = useState(getValue),
      value = _useState[0],
      setValue = _useState[1];

  var handler = useFunction(function () {
    var newValue = getValue();

    if (newValue !== value) {
      setValue(getValue);
    }
  });
  useEffect(function () {
    if (!isClient()) {
      return;
    }

    handler();
    mediaQueryLists.forEach(function (mql) {
      return mql.addListener(handler);
    });
    return function () {
      return mediaQueryLists.forEach(function (mql) {
        return mql.removeListener(handler);
      });
    };
  }, listenToChanges ? [queries, values, defaultValue] : []);
  return value;
};